<template>
  <div class="bg-[#00554A] h-screen">
    <van-nav-bar :title="t('deposito.title')" class="custom-nav-bar" :border="false">
      <template #left v-if="isFromPerson || isFromHome">
        <Button type="back" @click="onClickLeft" />
      </template>
      <template #right>
        <Button type="record" @click="goToRecord" />
        <!-- <img :src="getAssetsFile('SVG/icon_record.svg')" alt="" class="w-[16px] h-[16px]" @click="goToRecord"> -->
      </template>
    </van-nav-bar>
    <div class="m-[16px]">
      <div class="flex">
        <div class="w-[2px] h-full relative">
          <div class="w-full h-[28px] bg-[#00FFC7] transition-all duration-150"
            :style="{ 'transform': 'translateY(' + (activeTab * 100) + '%)' }" />
        </div>
        <div class="w-full">
          <div v-for="(tab, idx) in tabs" :key="tab.label" class="h-[28px] text-white text-[13px] pl-[10px]"
            :style="activeTab === idx ? 'background: linear-gradient(90deg, #003829 0%, #005542 100%)' : ''"
            @click="selectTab(idx)">
            <div class="inline-block h-full">
              <div class="h-full relative flex items-center">
                <div class="flex justify-between absolute right-0 top-0">
                  <div></div>
                  <div class="bitaos">RECO</div>
                </div>
                <div :class="{ 'text-[#00F8C2]': activeTab === idx }">{{ tab.label }}</div>
              </div>
            </div>
          </div>

        </div>
      </div>
      <div class="mt-[15px]">
        <div class="flex flex-wrap gap-[10px]">
          <div class="Channels" :class="{ 'selected': selectedChannelId === item.id }" v-for="item in reqyse"
            :key="item.id" @click="selectChannel(item.id)">
            {{ item.rechargeName }}
          </div>
        </div>
      </div>
      <div class="bg-[#339A74] mt-[15px] w-full h-[0.5px]"></div>
      <div class="moneyseary" v-if="inputSwitch">
        <div class="money-prefix">{{ VITE_symbol }}</div>
        <input v-model="searchText" class="search-input auth-input" type="number" step="1" min="0"
          :placeholder="dynamicPlaceholder" @input="handleInputChange" @keypress="handleKeyPress">
        <img :src="getAssetsFile('home/zu15.png')" alt="" class="money-icon" v-if="searchText != ''"
          @click="searchText = ''">
      </div>
      <!-- 充值选项区域 -->
      <div class="recharge-grid">
        <div v-for="(amount, idx) in rechargeOptions" :key="amount" class="recharge-item"
          :class="{ selected: selectedRechargeIdx === idx }" @click="selectRecharge(idx)">
          <span class="recharge-item-content">{{ numberFormat(amount) }}</span>
          <!-- 添加角标 -->
          <div v-if="getRatioForAmount(amount) && joinDayRecharge" class="recharge-badge"
            :class="{ 'badge-first': idx === selectedRechargeIdx }">
            +{{ Number((getRatioForAmount(amount) + 100).toFixed(2)) }}%
          </div>
        </div>
      </div>
      <!-- 每日充值活动勾选框 -->
      <div v-if="channelConfig.length > 0" class="day-recharge-checkbox">
        <div class="checkbox-container" @click="toggleDayRecharge">
          <div class="custom-checkbox" :class="{ 'checked': joinDayRecharge }">
            <img v-if="joinDayRecharge" :src="getAssetsFile('home/gouzhong.png')" alt="" class="check-icon">
            <div v-else class="w-[14px] h-[14px]" style="border-radius: 3px;background: #FFF;"></div>
          </div>
          <span class="checkbox-text">{{ t('deposito.joinDayRecharge') }}</span>
        </div>
      </div>
      <div class="mt-[28px] flex justify-center">
        <Button v-trans="{
          type: 'heartbeat',
          scale: 1.05,
          duration: 100
        }" type="medium" :class="{ animated: rechargeBtnAnimated }" :disabled="rechargeLoading"
          @click="handleRechargeClick">
          <van-loading v-if="rechargeLoading" type="spinner" color="#FFFFFF" size="16px" />
          <span v-else>{{ t('deposito.depositNow') }}</span>
        </Button>
      </div>
      <!-- <div class="mt-[28px] Recharge" :class="{ animated: rechargeBtnAnimated }" @click="handleRechargeClick">
        {{ t('deposito.depositNow') }}
      </div> -->
    </div>
    <!-- 新用户专属奖励弹窗 -->
    <RewardDialog :show="showRewardDialog" :amount="rewardDialogAmount" @update:show="showRewardDialog = $event"
      @confirm="handleRewardDialogConfirm" />
    <!-- 充值确认弹窗 -->
    <ConfirmDialog :show="showConfirmDialog" :message="t('deposito.redirectMessage')"
      @update:show="showConfirmDialog = $event" @confirm="handleConfirmDialogConfirm" />
  </div>
</template>

<script setup lang="ts">

import { Button } from "@/components/Button"
import { ref, onMounted, computed, onUnmounted, watch } from 'vue'
import { numberFormat } from '@/utils/formatter'
import { useUserStore } from '@/stores/modules/user'
import { useRouter } from 'vue-router'
import { useI18n } from 'vue-i18n'
import { getAssetsFile, getUrlParam, getCookie, setCookie } from '@/utils/pub-use'
import { APKTracking } from '@/utils/event-tracking'
import { trackPayClickNowButton } from '@/utils/firebase-analytics'
import { trackRechargeClick, trackPurchaseClick } from '@/utils/facebook-pixel-tracking'
// 添加 RewardDialog 导入
import RewardDialog from '@/components/RewardDialog.vue'
// 添加 ConfirmDialog 导入
import ConfirmDialog from '@/components/ConfirmDialog.vue'
import * as GameApi from "@/api/game";
const VITE_symbol = import.meta.env.VITE_SYMBOL
const userStore = useUserStore()
const router = useRouter()
const { t } = useI18n()

// 检查是否从个人中心跳转
const isFromPerson = computed(() => {
  return sessionStorage.getItem('fromPerson') === 'true'
})

// 检查是否从首页跳转
const isFromHome = computed(() => {
  return sessionStorage.getItem('fromHome') === 'true'
})

const onClickLeft = () => {
  if (isFromPerson.value) {
    // 如果是从个人中心来的，清除标记并返回个人中心
    sessionStorage.removeItem('fromPerson')
    router.push('/person')
  } else if (isFromHome.value) {
    // 如果是从首页来的，清除标记并返回首页
    sessionStorage.removeItem('fromHome')
    router.push('/')
  } else {
    router.back()
  }
}

// 跳转到充值记录页面
const goToRecord = () => {
  try {
    router.push({ name: 'registroDeDeposito' })
  } catch (error) {
    console.error('跳转失败:', error)
    // 如果跳转失败，尝试使用 name 跳转
    router.push({ name: 'registroDeDeposito' })
  }
}

const tabs = [
  { label: t('deposito.onlineDeposit') },
]
const activeTab = ref(0)
async function selectTab(idx) {
  activeTab.value = idx
}
import { useRoute } from 'vue-router'
const route = useRoute()
let params = {
  tag: null,
  gameName: null,
  pageNo: 1,
  pageSize: 20,
}

// 首先定义所有需要的响应式变量
const reqyse = ref([]);
const selectedChannelId = ref(4) // 默认选中ID为4的渠道
const rechargeOptions = ref([])
const selectedRechargeIdx = ref(-1)
const rechargeBtnAnimated = ref(false)
const searchText = ref('')
const VITE_PLATFORM = import.meta.env.VITE_PLATFORM
let reges = ref({
  chargeAmount: 0,
  currency: VITE_PLATFORM,
  channelId: 4,
  chargeItem: "",
  chargeType: 0,
});

// 添加渠道配置数据
const channelConfig = ref([])

// 添加每日充值活动状态
const joinDayRecharge = ref(false)

// 添加 inputSwitch 响应式变量
const inputSwitch = ref(false)

// 然后定义计算属性
const dynamicPlaceholder = computed(() => {
  const selectedChannel = reqyse.value.find(channel => channel.id === selectedChannelId.value)

  if (selectedChannel && selectedChannel.minAmount !== undefined && selectedChannel.maxAmount !== undefined) {
    // 格式化数字显示
    const minFormatted = numberFormat(selectedChannel.minAmount)
    const maxFormatted = numberFormat(selectedChannel.maxAmount)
    return `${minFormatted} - ${maxFormatted}`
  } else {
    // 如果没有minAmount和maxAmount，使用默认placeholder
    return t('deposito.amountPlaceholder')
  }
})

// 添加一个计算属性来检查当前输入值是否匹配预设金额
const currentInputMatchesPreset = computed(() => {
  if (!searchText.value) return -1

  // 将输入值与预设金额进行比较
  for (let i = 0; i < rechargeOptions.value.length; i++) {
    const presetNum = String(rechargeOptions.value[i]).replace(/\./g, '').replace(/,\d+$/, '')
    if (searchText.value === presetNum) {
      return i
    }
  }
  return -1
})

// 监听 searchText 变化，同步更新选中状态
watch(searchText, (newValue) => {
  const matchIndex = currentInputMatchesPreset.value
  selectedRechargeIdx.value = matchIndex
})

// 函数定义
function selectRecharge(idx) {
  selectedRechargeIdx.value = idx
  const raw = rechargeOptions.value[idx]
  const num = Number(raw.replace(/\./g, '').replace(/,\d+$/, ''))
  searchText.value = String(num)
}

// 处理输入变化，移除小数点
const handleInputChange = (event) => {
  const value = event.target.value
  // 移除所有非数字字符（包括小数点）
  const cleanValue = value.replace(/[^0-9]/g, '')
  searchText.value = cleanValue
}

// 阻止小数点输入
const handleKeyPress = (event) => {
  // 阻止小数点、减号等字符输入
  if (['.', '-', 'e', 'E'].includes(event.key)) {
    event.preventDefault()
  }
}

// 修改 updateRechargeOptions 函数，同时更新 inputSwitch
const updateRechargeOptions = (channelId) => {
  const selectedChannel = reqyse.value.find(channel => channel.id === channelId)

  if (selectedChannel) {
    // 更新 inputSwitch
    inputSwitch.value = selectedChannel.inputSwitch || false

    if (selectedChannel.rechargeItem && Array.isArray(selectedChannel.rechargeItem)) {
      // 使用选中渠道的充值档位
      rechargeOptions.value = selectedChannel.rechargeItem.map(item => String(item))
    } else {
      // 如果没有rechargeItem，使用默认值
      rechargeOptions.value = ['10', '30', '50', '100', '500', '1000', '5000', '10000', '50000']
    }
  } else {
    // 如果没有找到渠道，使用默认值
    inputSwitch.value = false
    rechargeOptions.value = ['10', '30', '50', '100', '500', '1000', '5000', '10000', '50000']
  }

  // 同时更新输入框的min和max属性
  updateInputConstraints(channelId)
}

// 新增函数：更新输入框的约束条件
const updateInputConstraints = (channelId) => {
  const selectedChannel = reqyse.value.find(channel => channel.id === channelId)

  if (selectedChannel && selectedChannel.minAmount !== undefined && selectedChannel.maxAmount !== undefined) {
    // 这里可以添加对输入框min和max属性的更新逻辑
  }
}

// 使用全局socket实例监听余额变化
const socket = window.$socket

// 监听用户余额变化事件
const handleAmountChange = (info) => {
  if (!info) return

  // 处理 { code: 0, data: ... } 格式
  let walletData = info
  if (info.code === 0 && info.data) {
    walletData = info.data
  }

  // 如果walletData是数组，说明包含多个钱包信息，需要合并更新
  if (Array.isArray(walletData)) {
    walletData.forEach((walletItem: any) => {
      if (walletItem && walletItem.currencyId !== undefined && walletItem.availableAccount !== undefined) {
        const walletInfos = userStore.userInfo.userWalletInfos || []
        const existingIndex = walletInfos.findIndex((item: any) => item.currencyId === walletItem.currencyId)

        if (existingIndex >= 0) {
          walletInfos[existingIndex] = {
            ...walletInfos[existingIndex],
            availableAccount: walletItem.availableAccount
          }
        } else {
          walletInfos.push(walletItem)
        }

        userStore.userInfo.userWalletInfos = walletInfos
      }
    })
  }
  // 如果walletData是对象且包含currencyId，说明是单个钱包信息
  else if (walletData && typeof walletData === 'object' && walletData.currencyId !== undefined && walletData.availableAccount !== undefined) {
    const walletInfos = userStore.userInfo.userWalletInfos || []
    const existingIndex = walletInfos.findIndex((item: any) => item.currencyId === walletData.currencyId)

    if (existingIndex >= 0) {
      walletInfos[existingIndex] = {
        ...walletInfos[existingIndex],
        availableAccount: walletData.availableAccount
      }
      userStore.userInfo.userWalletInfos = walletInfos
    } else {
      walletInfos.push(walletData)
      userStore.userInfo.userWalletInfos = walletInfos
    }
  }
  // 如果walletData只有availableAccount没有currencyId，重新获取完整用户信息
  else if (walletData && walletData.availableAccount !== undefined && walletData.currencyId === undefined) {
    // 没有currencyId时，重新获取完整用户信息，确保数据准确
    console.log('[充值页面] Socket余额变化事件缺少currencyId，重新获取用户信息')
    userStore.info().catch(err => {
      console.error('[充值页面] 重新获取用户信息失败:', err)
    })
  }
}

// 添加 RewardDialog 状态
const showRewardDialog = ref(false)
const rewardDialogAmount = ref<any>({})

// 添加确认弹窗状态
const showConfirmDialog = ref(false)
// 添加 loading 状态
const rechargeLoading = ref(false)
// 存储充值URL，用于确认后跳转
const chargeUrl = ref('')

// 处理新用户专属奖励socket事件
const handleNewUserExclusiveReward = (data) => {


  console.log('收到新用户专属奖励事件:', data)
  console.log('数据类型:', typeof data)
  console.log('是否为数组:', Array.isArray(data))
  let amount = ''

  if (Array.isArray(data) && data.length >= 2) {
    // 如果是数组格式 ["new_user_exclusive_reward", "188.64"]
    amount = data[1]
  } else if (typeof data === 'string') {
    // 如果直接是字符串 "188.64"
    amount = data
  } else {
    console.log('未知的数据格式:', data)
    return
  }

  console.log('提取的金额:', amount)
  rewardDialogAmount.value = amount
  console.log('设置到弹窗的金额:', rewardDialogAmount.value)
  showRewardDialog.value = true
}

// 处理 RewardDialog 确认事件
const handleRewardDialogConfirm = () => {
  showRewardDialog.value = false
  // 可以在这里添加其他逻辑，比如更新用户余额等
}

// 处理确认弹窗确认事件
const handleConfirmDialogConfirm = () => {
  showConfirmDialog.value = false
  // 跳转到充值页面
  if (chargeUrl.value) {
    window.open(chargeUrl.value, "_blank")
  }
}

onMounted(async () => {
  // 存储 URL 参数中的 channelId 和 channelName 到 cookie
  const urlChannelId = getUrlParam("channelId");
  if (urlChannelId) {
    setCookie('channelId', urlChannelId)
  }

  const urlChannelName = getUrlParam("channelName");
  if (urlChannelName) {
    setCookie('channelName', urlChannelName)
  }

  try {
    // 获取渠道列表
    const res1 = await GameApi.channellist();
    reqyse.value = res1.data;

    // 初始化默认渠道的充值档位
    if (res1.data && res1.data.length > 0) {
      // 找到默认选中的渠道（ID为4）
      const defaultChannel = res1.data.find(channel => channel.id === 4)
      if (defaultChannel) {
        updateRechargeOptions(4)
        // 默认调用 getConfig 接口
        await callGetConfig(4)
      } else {
        // 如果找不到ID为4的渠道，使用第一个渠道
        const firstChannelId = res1.data[0].id
        updateRechargeOptions(firstChannelId)
        selectedChannelId.value = firstChannelId
        reges.value.channelId = firstChannelId
        // 默认调用 getConfig 接口
        await callGetConfig(firstChannelId)
      }
    } else {
      // 如果接口返回空数据，使用默认值
      rechargeOptions.value = ['10', '30', '50', '100', '500', '1000', '5000', '10000', '50000']
    }

  } catch (error) {
    console.error('获取渠道列表失败:', error)
    // 出错时使用默认值
    rechargeOptions.value = ['10', '30', '50', '100', '500', '1000', '5000', '10000', '50000']
  }

  // 确保socket已连接并注册余额变化监听
  if (socket && socket.isConnected()) {
    socket.on('user_amount_change_notice', handleAmountChange)
    // 添加新用户专属奖励事件监听
    socket.on('new_user_exclusive_reward', handleNewUserExclusiveReward)
  }
})

// 提取 getConfig 调用逻辑为独立函数
const callGetConfig = async (channelId) => {
  try {
    const response = await GameApi.getConfig({ channelId })
    console.log('渠道配置:', response.data)
    // 保存渠道配置数据
    channelConfig.value = response.data || []
    // 如果有配置数据，默认勾选
    if (channelConfig.value.length > 0) {
      joinDayRecharge.value = true
    }
  } catch (error) {
    console.error('获取渠道配置失败:', error)
    channelConfig.value = []
    joinDayRecharge.value = false
  }
}

// 修改选择渠道的函数，复用 callGetConfig 函数
const selectChannel = async (id) => {
  selectedChannelId.value = id
  reges.value.channelId = id

  // 调用 getConfig 接口获取渠道配置
  await callGetConfig(id)

  // 根据选中的渠道更新充值选项
  updateRechargeOptions(id)

  // 重置选中的充值金额
  selectedRechargeIdx.value = -1
  searchText.value = ''
}

// 获取对应金额的ratio值
const getRatioForAmount = (amount) => {
  const configItem = channelConfig.value.find(item => item.amount === Number(amount))
  return configItem ? configItem.ratio : null
}

// 切换每日充值活动勾选状态
const toggleDayRecharge = () => {
  joinDayRecharge.value = !joinDayRecharge.value
}

onUnmounted(() => {
  // 清理socket事件监听
  if (socket) {
    socket.off('user_amount_change_notice', handleAmountChange)
    // 移除新用户专属奖励事件监听
    socket.off('new_user_exclusive_reward', handleNewUserExclusiveReward)
  }
})

async function handleRechargeClick() {
  trackPayClickNowButton()
  rechargeBtnAnimated.value = false
  void rechargeBtnAnimated.value // 强制刷新
  setTimeout(() => { rechargeBtnAnimated.value = true }, 10)
  setTimeout(() => { rechargeBtnAnimated.value = false }, 400)

  // 只保留数字
  reges.value.chargeAmount = Number(String(searchText.value).replace(/[^0-9]/g, ''))

  // 上报点击充值按钮事件
  const apkTracking = new APKTracking()
  apkTracking.trackRechargeClick({
    amount: reges.value.chargeAmount,
    currency: reges.value.currency,
  })

  const adjustTracking = window.$adjustTracking
  if (adjustTracking) {
    adjustTracking.trackRechargeClick(reges.value.chargeAmount, reges.value.currency)
  }
  const appsFlyerTracking = window.$appsFlyerTracking
  if (appsFlyerTracking) {
    appsFlyerTracking.trackRechargeClick(reges.value.chargeAmount, reges.value.currency)
  }
  // 判断是否是首充：通过用户信息中的 firstRechargeRebate 字段判断
  // 如果 firstRechargeRebate === true，说明还没有首充过，这次点击就是首充点击
  const isFirstRecharge = userStore.userInfo?.firstRechargeRebate === true

  // 根据首充/复充分别上报不同的 Facebook Pixel 点击事件
  if (isFirstRecharge) {
    // 首充点击上报 PurchaseClick 事件
    trackPurchaseClick({
      value: reges.value.chargeAmount,
      currency: reges.value.currency
    })
    console.log('[充值点击] Facebook Pixel 首充点击上报:', {
      amount: reges.value.chargeAmount,
      currency: reges.value.currency,
      event: 'PurchaseClick'
    })
  } else {
    // 复充点击上报 RechargeClick 事件
    trackRechargeClick({
      value: reges.value.chargeAmount,
      currency: reges.value.currency
    })
    console.log('[充值点击] Facebook Pixel 复充点击上报:', {
      amount: reges.value.chargeAmount,
      currency: reges.value.currency,
      event: 'RechargeClick'
    })
  }

  // 显示 loading
  rechargeLoading.value = true

  try {
    // 调用充值接口，添加 joinDayRecharge 字段
    const res = await GameApi.gorecharge({
      ...reges.value,
      giftToken: route.query.giftToken,
      home: location.origin,
      joinDayRecharge: joinDayRecharge.value
    })
    // 接口返回后取消 loading
    rechargeLoading.value = false

    // 保存充值URL
    if (res.data.chargeUrl != "" && res.data.chargeUrl != null) {
      chargeUrl.value = res.data.chargeUrl
      // 显示确认弹窗
      showConfirmDialog.value = true
    }

    // 更新用户信息
    userStore.info().then(() => {
    }).catch(err => {
    })
  } catch (err) {
    // 出错时也要取消 loading
    rechargeLoading.value = false
    console.error('充值接口调用失败:', err)
  }
}
</script>

<style lang="scss" scoped>
.custom-nav-bar {
  height: 56px;
  box-shadow: 0px 2px 3px 0px rgba(0, 0, 0, 0.3), 0px -2px 22px 0px rgba(53, 189, 128, 0.61);

  &>* {
    height: 100%;
  }
}

.tab-bar {

  position: relative;
  margin-top: 30px;

  padding-bottom: 18px;
  overflow: hidden;

  gap: 20px;
}

.tab-item {

  cursor: pointer;
  position: relative;
  font-size: 12px;
  font-weight: 600;
  color: #3b9872;
  transition: color 0.2s;
  user-select: none;

  min-width: 0;
  position: relative;
}

.tab-item:last-child {
  margin-right: 0;
}

.tab-item.active {
  color: #fff;
}

.tab-bar-active {
  position: absolute;
  top: 0;
  bottom: 0;
  background: #18AF5F;
  border-radius: 2px;
  transition: left 0.2s, width 0.2s;
  z-index: 2;
  height: 100%;
}

.tab-bar-active.single {
  position: absolute;
  top: -1px;
  /* 向上偏移，避免被父元素限制 */
  left: 0;
  width: 100%;
  height: 1.5px;
  background: #18AF5F;
  z-index: 288;
  border-radius: 2px;
}

.tab-item.active {
  color: #fff;
}

.tab-item .tab-label {
  margin-left: 5px;
  font-weight: 400;
  font-size: 12px;

}

.bitaos {
  width: 23px;
  height: 10px;
  background: #DA4729;
  border-radius: 3px;
  color: #FFFFFF;
  font-size: 7px;
  line-height: 10px;
  text-align: center;
  font-weight: bold;
}

.Channels {
  width: 106px;
  height: 39px;
  background: #003C31;
  /* 未选中时的背景色 */
  box-shadow: 1px 1px 2px 0px rgba(21, 76, 55, 0.32);
  border-radius: 6px;
  line-height: 39px;
  text-align: center;
  color: #60B58A;
  /* 未选中时的文字颜色 */
  cursor: pointer;
  transition: all 0.2s ease;
  /* 添加过渡动画 */
  border: 1px solid transparent;
  /* 添加透明边框 */
}

.Channels.selected {
  background: linear-gradient(0deg, #18926B 0%, #299263 100%);
  /* 选中时的背景色 */
  color: #FFFFFF;
  /* 选中时的文字颜色 */
  border-color: #18AF5F;
  /* 选中时的边框颜色 */
  box-shadow: 0px 2px 1px 0px rgba(0, 26, 26, 0.71), 0px 1px 0px 0px #5DC09B, 0px -1px 0px 0px #46B792;
  /* 选中时的阴影 */
}

/* 添加悬停效果 */
.Channels:hover:not(.selected) {
  background: #2A7A5A;
  color: #7BC4A0;
}

.moneyseary {
  height: 49px;
  background: #003C31;
  position: relative;
  border-radius: 6px;
  display: flex;
  align-items: center;
  padding: 10px 7px;
  margin-top: 17px;
  gap: 8px;
  box-shadow: inset 0px 2px 1px 0px rgba(0, 28, 24, 0.66);
}

.money-prefix {
  color: #fff;
  font-size: 12px;
  flex-shrink: 0;
  font-weight: bold;
}

.search-input {
  flex: 1;
  border: none;
  outline: none;
  background: transparent;
  color: #fff;
  font-size: 12px;
  height: 100%;
  margin-left: 5px;
  margin-right: 5px;
  /* 隐藏 number input 的上下箭头 */
  -moz-appearance: textfield;
  appearance: textfield;
}

.search-input::-webkit-inner-spin-button,
.search-input::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.money-icon {
  width: 11px;
  height: 11px;
  flex-shrink: 0;
  margin-right: 5px;
}

input::placeholder {
  color: #50B388;
  font-size: 12px;
}

.auth-input {
  caret-color: #50d38c;
}

.donse {
  width: 107px;
  height: 38px;
  background: #1F6749;
  box-shadow: 1px 1px 2px 0px rgba(21, 76, 55, 0.32);
  border-radius: 6px;
  color: #60B58A;
  font-size: 15px;
  font-weight: 500;
  line-height: 38px;
  text-align: center;
}

.recharge-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;
  margin-top: 18px;
}

.recharge-item {
  background: #003C31;
  border-radius: 8px;
  color: #60B58A;
  font-size: 15px;
  font-weight: 500;
  height: 38px;
  line-height: 38px;
  text-align: center;
  transition: background 0.2s, color 0.2s, font-weight 0.2s;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.recharge-item.selected {
  background: linear-gradient(0deg, #18926B 0%, #299263 100%);
  box-shadow: 0px 2px 1px 0px rgba(0, 26, 26, 0.71), 0px 1px 0px 0px #5DC09B, 0px -1px 0px 0px #46B792;
  color: #fff;
  font-weight: bold;
}

/* 角标样式 */
.recharge-badge {
  position: absolute;
  top: -2px;
  right: -2px;
  background: getPath('activity/jiaobiao2.png') no-repeat;
  background-size: 100% 100%;
  color: white;
  font-size: 10px;
  font-weight: bold;
  padding: 2px 6px;
  min-width: 20px;
  text-align: center;
  line-height: 1.2;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  max-width: 50px;
  height: 20px;
}

/* 第一个选项的角标样式 */
.recharge-badge.badge-first {
  background: getPath('activity/jiaobiao1.png') no-repeat;
  background-size: 100% 100%;
}

.Recharge {
  height: 40px;
  background: linear-gradient(180deg, #13C769 0%, #1C9755 100%);
  border-radius: 10px;
  color: #FFFFFF;
  font-size: 15px;
  font-weight: bold;
  text-align: center;
  line-height: 40px;
  position: relative;
  overflow: hidden;
  width: 80%;
  margin: 0 auto;
  margin-top: 25px;
}

.Recharge::before {
  content: '';
  position: absolute;
  left: 50%;
  top: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(180deg, #13C769 0%, #1C9755 100%);
  opacity: 0.25;
  border-radius: 6px;
  transform: translateX(-50%) scaleX(0);
  transition: transform 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  z-index: 1;
  pointer-events: none;
}

.Recharge.animated::before {
  transform: translateX(-50%) scaleX(1);
}

.Recharge,
.Recharge>* {
  position: relative;
  z-index: 2;
}

/* 每日充值活动勾选框样式 */
.day-recharge-checkbox {
  margin-top: 20px;
  margin-bottom: 10px;
}

.checkbox-container {
  display: flex;
  align-items: center;
  cursor: pointer;
  padding-top: 0px;
  border-radius: 6px;
  transition: background 0.2s;
}

.custom-checkbox {
  width: 18px;
  height: 18px;
  border-radius: 3px;
  margin-right: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;
}


.check-icon {
  width: 14px;
  height: 14px;
}

.checkbox-text {
  color: #FFFFFF;
  font-size: 13px;
  font-weight: 500;
}
</style>
<route lang="json5">
    {
      name: 'Deposito',
      meta: {
        title: 'Deposito',
        i18n: 'menus.deposito'
      },
    }
</route>
